module.exports = __webpack_public_path__ + "img/inge-v9-2.8744211d.png";